import { render, staticRenderFns } from "./TooltipBovines.vue?vue&type=template&id=b6f63710&scoped=true"
import script from "./TooltipBovines.vue?vue&type=script&lang=js"
export * from "./TooltipBovines.vue?vue&type=script&lang=js"
import style0 from "./TooltipBovines.vue?vue&type=style&index=0&id=b6f63710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f63710",
  null
  
)

export default component.exports